<template>
  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
   viewBox="0 0 390 231.5" style="enable-background:new 0 0 390 231.5;" xml:space="preserve">
    <g>
      <defs>
        <rect id="t6_1_" y="69.7" width="92.2" height="92.2"/>
      </defs>
      <clipPath id="t6_2_">
        <use xlink:href="#t6_1_"  style="overflow:visible;"/>
      </clipPath>
      <g class="st0">
        <g>
          <defs>
            <path id="t6_3_" d="M0,152.8V78.7c0-5,4-9,9-9h74.2c5,0,9,4,9,9v74.2c0,5-4,9-9,9H9C4,161.8,0,157.8,0,152.8z"/>
          </defs>
          <clipPath id="t6_4_">
            <use xlink:href="#t6_3_"  style="overflow:visible;"/>
          </clipPath>
          <g class="st1">
            <path class="st2" d="M0,161.8V69.7h92.2v92.2H0z"/>
          </g>
        </g>
      </g>
    </g>
    <g>
      <defs>
        <rect id="t6_5_" x="297.9" y="69.7" width="92.2" height="92.2"/>
      </defs>
      <clipPath id="t6_6_">
        <use xlink:href="#t6_5_"  style="overflow:visible;"/>
      </clipPath>
      <g class="st3">
        <g>
          <defs>
            <path id="t6_7_" d="M297.9,152.8V78.7c0-5,4-9,9-9H381c5,0,9,4,9,9v74.2c0,5-4,9-9,9h-74.2
              C301.9,161.8,297.9,157.8,297.9,152.8z"/>
          </defs>
          <clipPath id="t6_8_">
            <use xlink:href="#t6_7_"  style="overflow:visible;"/>
          </clipPath>
          <g class="st4">
            <path class="st2" d="M297.9,161.8V69.7H390v92.2H297.9z"/>
          </g>
        </g>
      </g>
    </g>
    <g>
      <defs>
        <rect id="t6_9_" x="229.9" width="92.2" height="92.2"/>
      </defs>
      <clipPath id="t6_10_">
        <use xlink:href="#t6_9_"  style="overflow:visible;"/>
      </clipPath>
      <g class="st5">
        <g>
          <defs>
            <path id="t6_11_" d="M229.9,83.2V9c0-5,4-9,9-9h74.2c5,0,9,4,9,9v74.2c0,5-4,9-9,9h-74.2C233.9,92.2,229.9,88.1,229.9,83.2z"
              />
          </defs>
          <clipPath id="t6_12_">
            <use xlink:href="#t6_11_"  style="overflow:visible;"/>
          </clipPath>
          <g class="st6">
            <path class="st2" d="M229.9,92.2V0h92.2v92.2H229.9z"/>
          </g>
        </g>
      </g>
    </g>
    <g>
      <defs>
        <rect id="t6_13_" x="73.2" y="69.7" width="92.2" height="92.2"/>
      </defs>
      <clipPath id="t6_14_">
        <use xlink:href="#t6_13_"  style="overflow:visible;"/>
      </clipPath>
      <g class="st7">
        <g>
          <defs>
            <path id="t6_15_" d="M73.2,152.8V78.7c0-5,4-9,9-9h74.2c5,0,9,4,9,9v74.2c0,5-4,9-9,9H82.2C77.2,161.8,73.2,157.8,73.2,152.8
              z"/>
          </defs>
          <clipPath id="t6_16_">
            <use xlink:href="#t6_15_"  style="overflow:visible;"/>
          </clipPath>
          <g class="st8">
            <path class="st2" d="M73.2,161.8V69.7h92.2v92.2H73.2z"/>
          </g>
        </g>
      </g>
    </g>
    <g>
      <defs>
        <rect id="t6_17_" x="69.7" y="0" width="92.2" height="92.2"/>
      </defs>
      <clipPath id="t6_18_">
        <use xlink:href="#t6_17_"  style="overflow:visible;"/>
      </clipPath>
      <g class="st9">
        <g>
          <defs>
            <path id="t6_19_" d="M78.7,0h74.2c5,0,9,4,9,9v74.2c0,5-4,9-9,9H78.7c-5,0-9-4-9-9V9C69.7,4,73.7,0,78.7,0z"/>
          </defs>
          <clipPath id="t6_20_">
            <use xlink:href="#t6_19_"  style="overflow:visible;"/>
          </clipPath>
          <g class="st10">
            <path class="st2" d="M69.7,0h92.2v92.2H69.7V0z"/>
          </g>
        </g>
      </g>
    </g>
    <g>
      <defs>
        <rect id="t6_21_" x="69.7" y="139.4" width="92.2" height="92.2"/>
      </defs>
      <clipPath id="t6_22_">
        <use xlink:href="#t6_21_"  style="overflow:visible;"/>
      </clipPath>
      <g class="st11">
        <g>
          <defs>
            <path id="t6_23_" d="M78.7,139.4h74.2c5,0,9,4,9,9v74.2c0,5-4,9-9,9H78.7c-5,0-9-4-9-9v-74.2
              C69.7,143.4,73.7,139.4,78.7,139.4z"/>
          </defs>
          <clipPath id="t6_24_">
            <use xlink:href="#t6_23_"  style="overflow:visible;"/>
          </clipPath>
          <g class="st12">
            <path class="st2" d="M69.7,139.4h92.2v92.2H69.7V139.4z"/>
          </g>
        </g>
      </g>
    </g>
    <g>
      <defs>
        <rect id="t6_25_" x="229.9" y="139.4" width="92.2" height="92.2"/>
      </defs>
      <clipPath id="t6_26_">
        <use xlink:href="#t6_25_"  style="overflow:visible;"/>
      </clipPath>
      <g class="st13">
        <g>
          <defs>
            <path id="t6_27_" d="M238.9,139.4h74.2c5,0,9,4,9,9v74.2c0,5-4,9-9,9h-74.2c-5,0-9-4-9-9v-74.2
              C229.9,143.4,233.9,139.4,238.9,139.4z"/>
          </defs>
          <clipPath id="t6_28_">
            <use xlink:href="#t6_27_"  style="overflow:visible;"/>
          </clipPath>
          <g class="st14">
            <path class="st2" d="M229.9,139.4h92.2v92.2h-92.2V139.4z"/>
          </g>
        </g>
      </g>
    </g>
    <g>
      <defs>
        <rect id="t6_29_" x="16.3" y="16.3" width="355.3" height="199"/>
      </defs>
      <clipPath id="t6_30_">
        <use xlink:href="#t6_29_"  style="overflow:visible;"/>
      </clipPath>
      <g class="st15">
        <g>
          <defs>
            <path id="t6_31_" d="M39.3,16.3H348c6.1,0,12,2.4,16.3,6.7s6.7,10.2,6.7,16.3v153c0,6.1-2.4,11.9-6.7,16.3
              s-10.2,6.7-16.3,6.7H39.3c-6.1,0-11.9-2.4-16.3-6.7c-4.3-4.3-6.7-10.2-6.7-16.3v-153c0-6.1,2.4-11.9,6.7-16.3
              C27.3,18.7,33.2,16.3,39.3,16.3z"/>
          </defs>
          <clipPath id="t6_32_">
            <use xlink:href="#t6_31_"  style="overflow:visible;"/>
          </clipPath>
          <g class="st16">
            <path class="st17" d="M16.3,16.3h354.5v199H16.3V16.3z"/>
          </g>
        </g>
      </g>
    </g>
    <g>
      <defs>
        <rect id="t6_33_" x="117.9" y="40.1" width="151.4" height="151.4"/>
      </defs>
      <clipPath id="t6_34_">
        <use xlink:href="#t6_33_"  style="overflow:visible;"/>
      </clipPath>
      <g class="st18">
        <g>
          <defs>
            <path id="t6_35_" d="M193.6,40.1c-41.8,0-75.7,33.9-75.7,75.7s33.9,75.7,75.7,75.7s75.7-33.9,75.7-75.7
              S235.5,40.1,193.6,40.1z"/>
          </defs>
          <clipPath id="t6_36_">
            <use xlink:href="#t6_35_"  style="overflow:visible;"/>
          </clipPath>
          <g class="st19">
            <path class="st2" d="M117.9,40.1h151.4v151.4H117.9V40.1z"/>
          </g>
        </g>
      </g>
    </g>
    </svg>
</template>
<script>
export default {
  name: 't6'
}
</script>

<style scoped>
  svg {
    width: 100%;
    height: 100%;
  }
  .st0{clip-path:url(#t6_2_);}
  .st1{clip-path:url(#t6_4_);}
  .st2{fill:#2C6EDF;}
  .st3{clip-path:url(#t6_6_);}
  .st4{clip-path:url(#t6_8_);}
  .st5{clip-path:url(#t6_10_);}
  .st6{clip-path:url(#t6_12_);}
  .st7{clip-path:url(#t6_14_);}
  .st8{clip-path:url(#t6_16_);}
  .st9{clip-path:url(#t6_18_);}
  .st10{clip-path:url(#t6_20_);}
  .st11{clip-path:url(#t6_22_);}
  .st12{clip-path:url(#t6_24_);}
  .st13{clip-path:url(#t6_26_);}
  .st14{clip-path:url(#t6_28_);}
  .st15{clip-path:url(#t6_30_);}
  .st16{clip-path:url(#t6_32_);}
  .st17{fill:#85B0F9;}
  .st18{clip-path:url(#t6_34_);}
  .st19{clip-path:url(#t6_36_);}
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/PosSettings/svg/t6.vue